export const UPDATE_PIN = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true' ? 'update/pin' : 'consumer/update/pin';
export const UPDATE_PHONE = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true' ? 'update/phone' : 'consumer/update/phone';
export const CONFIRM_PHONE = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? 'update/phone/confirm'
  : 'consumer/update/phone/confirm';
export const REGISTER = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true' ? 'registration' : 'consumer/registration';
export const DISABLE = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true' ? 'disable' : 'consumer/disable';
export const PIN_CODE_SEND = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? 'pin-code/send'
  : 'consumer/pin-code/send';
export const PIN_CODE_CONFIRM = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? 'pin-code/confirm'
  : 'consumer/pin-code/confirm';
export const UPDATE_PASSWORD = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? 'update-password'
  : 'consumer/update-password';
export const IN_APP_OTP = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? 'in-app-otp'
  : 'consumer/in-app-otp';
